import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupFilesHubInit" */ './lazyIndex');
});
export var lazySetGroupFilesHubCallbacks = new LazyAction(lazyModule, function (m) { return m.setGroupFilesHubCallbacks; });
//# sourceMappingURL=index.js.map